import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import { BootstrapVue } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import Vuelidate from 'vuelidate'
import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-sugar.css';
import VueLodash from 'vue-lodash'
import lodash from 'lodash'

import firebase from "firebase/app";
import 'firebase/firestore'

import LoadingButton from "@/components/shared/LoadingButton"
import AddElementDialog from "@/components/shared/AddElementDialog"
import EditElementDialog from "@/components/shared/EditElementDialog"
import UploadFileDialog from "@/components/shared/UploadFileDialog"
import EditFileDialog from "@/components/shared/EditFileDialog"
import FileCard from "@/components/shared/FileCard"
import FilePreviewDialog from "@/components/shared/FilePreviewDialog"
import FileThumbnailDialog from "@/components/shared/FileThumbnailDialog"
import AddUserDialog from "@/components/shared/AddUserDialog"

Vue.component("LoadingButton", LoadingButton);
Vue.component("AddElementDialog", AddElementDialog);
Vue.component("EditElementDialog", EditElementDialog);
Vue.component("UploadFileDialog", UploadFileDialog);
Vue.component("EditFileDialog", EditFileDialog);
Vue.component("FileCard", FileCard);
Vue.component("FilePreviewDialog", FilePreviewDialog);
Vue.component("AddUserDialog", AddUserDialog);
Vue.component("FileThumbnailDialog", FileThumbnailDialog);

Vue.use(BootstrapVue);
Vue.use(Vuelidate);
Vue.use(VueToast);
Vue.use(require('vue-moment'));
Vue.use(VueLodash, { lodash: lodash })

Vue.config.productionTip = false;

const firebaseConfig = {
  apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
  authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.VUE_APP_FIREBASE_APP_ID,
};

firebase.initializeApp(firebaseConfig);

const db = firebase.firestore();

Vue.prototype.$db = db;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js